export default __webpack_public_path__ + "static/media/image.freedom-college.f36bb50c.png";